<div
    class="custom-tooltip-content"
    [innerHTML]="content"></div>
